<template>
  <div :class="{ 'waste-streams--highlighted': hasActiveWasteStream }" class="waste-streams o-grid o-grid--center">
    <div v-for="(wasteStream, index) in wasteStreams" :key="index" class="waste-stream o-grid__col u-1/12">
      <a
        href="javascript:void(0)"
        :class="{ 'waste-stream__item--active': activeWasteStreamId === wasteStream.id }"
        class="waste-stream__item"
        @click="setActiveWasteStreamId(wasteStream.id)"
      >
        <img v-show="wasteStream.icon" :src="wasteStream.icon" :alt="wasteStream.name" />
        <span class="arrow"></span>
      </a>
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types'
import store from '../Store/store'

export default {
  name: 'WasteStreams',
  components: {},
  props: {
    municipalityId: VueTypes.number.def(1),
    wasteTypePageId: VueTypes.number
  },
  data() {
    return {}
  },
  computed: {
    wasteStreams() {
      return store.getters['waste/getWasteStreams']
    },
    activeWasteStreamId() {
      return store.getters['waste/getActiveWasteStreamId']
    },
    hasActiveWasteStream() {
      return this.activeWasteStreamId > 0
    }
  },
  created() {
    store.dispatch('waste/loadWasteStreams', this.municipalityId).then(() => {
      if (this.wasteTypePageId) {
        store.dispatch('waste/setActiveWasteStreamId', this.wasteTypePageId.toString())
      }
    })
  },
  methods: {
    setActiveWasteStreamId(id) {
      store.dispatch('waste/clearActiveSynonym')
      store.dispatch('waste/clearActiveWasteType')
      store.dispatch('waste/setActiveWasteStreamId', id)
      store.dispatch('waste/setShowResults', true)
    }
  }
}
</script>
